import { Component, ElementRef, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NewContactComponent } from '../../contact/new-contact/new-contact.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { SalesPersonService } from '../../../../services/sales-person.service';
import { LoaderComponent } from "../../../loader/loader.component";
import { salesPerson } from '../../../../model/masters.model';
import { CustomerService } from '../../../../services/customer.service';
import { ContactListComponent } from "../../contact/contact-list/contact-list.component";

@Component({
  selector: 'app-new-sales-person',
  standalone: true,
  providers: [DialogService, MessageService],
  templateUrl: './new-sales-person.component.html',
  styleUrl: './new-sales-person.component.scss',
  imports: [SharedModule, CommonModule, LoaderComponent, ContactListComponent]
})
export class NewSalesPersonComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;

  selectedFile: File | null = null;
  previewImage: string | null = null;
  uploadimage: any;
  submitted: boolean = false;
  ref: DynamicDialogRef = new DynamicDialogRef;
  // previewImage: SafeUrl | undefined;
  saveImage: Blob | undefined;
  selectedSalesperson: any;
  isEditMode: boolean = false;
  salespersonId: number | undefined;
  Addressid: number | undefined;
  stateList: any[] = [];
  filterStates: any[] = [];
  isManual: boolean = false;

  loader: any;

  constructor(private route: Router, private router: ActivatedRoute, public dialogService: DialogService, private salespersonservice: SalesPersonService,
    private messageService: MessageService, private sanitizer: DomSanitizer, private customerService: CustomerService) {
  }

  ngOnInit() {
    document.title = 'Create Salesperson';
    this.getStateList();

    this.router.queryParams.subscribe(params => {
      this.salespersonId = params['salespersonId'];
      this.isEditMode = !!this.salespersonId;

      if (this.isEditMode) {
        document.title = 'Update Salesperson';
        // If in edit mode, fetch the salesperson details
        this.salespersonservice.getSalespersonById(this.salespersonId).subscribe(
          (salesperson: any) => {
            this.Addressid = salesperson.addressId
            this.salesPersonForm.patchValue(salesperson);
            if (salesperson.salespersonImage) {
              this.setBase64Image(salesperson.salespersonImage);
            }
            else {
              console.error('Salesperson data not found.');
            }
          },
          (error: any) => {
            console.error('Error fetching salesperson data:', error);
          }
        );
      } else {
        this.resetForm();

        this.salesPersonForm.get('manualEntry')?.setValue(false);
        this.manualEntry();
      }
    });
    // if (!this.isEditMode) {
    //   this.manualEntry();
    // }
  }

  setBase64Image(imageBase64: string) {
    this.previewImage = `data:image/jpeg;base64,${imageBase64}`;
  }

  resetForm() {
    this.salesPersonForm.reset();
    this.salesPersonForm.controls.manualEntry.setValue(true);
    this.salesPersonForm.controls.address.controls.country.setValue('India');
  }

  salesPersonForm = new FormGroup({
    //salespersonCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    salespersonCode: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    salespersonName: new FormControl('', Validators.required),
    salespersonImage: new FormControl(),
    salespersonDescription: new FormControl(''),
    employeeCode: new FormControl(),
    managerCode: new FormControl(),
    isActive: new FormControl(true),
    addressid: new FormControl(),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]),
      country: new FormControl('India', Validators.required),
      stateCode: new FormControl(''),
      CreatedBy: new FormControl(''),
      UpdatedBy: new FormControl(''),
    }),
    phone: new FormControl('', Validators.pattern(/^\d{10}$/)),
    mobile: new FormControl('', [Validators.pattern(/^\d{10}$/)]),
    email: new FormControl('', [Validators.email]),
  });

  salesPerson: salesPerson[] = [];

  // onFileSelected(event: any) {
  //   if (event) {
  //     const file = event.target.files[0];
  //     this.saveImage = file;
  //     this.previewImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
  //   }
  // }

  cancel() {
    this.route.navigate(['/home/listsalesPerson']);
  }

  showContact() {
    this.ref = this.dialogService.open(NewContactComponent, {
      header: 'Create Contact',
      width: '80%'
    });
  }

  saveSalesperson(data: any, isEditMode: boolean) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    if (isEditMode) {
      this.updateSalesperson(data);
    } else {
      this.createSalesperson(data);
    }
  }

  createSalesperson(data: any) {
    data.salespersonCode = data.salespersonCode.toString();
    const username = localStorage.getItem('username');
    if (username) {
      data.createdBy = username;
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'User not logged in' });
      return;
    }

    this.loader = true;
    this.salespersonservice.createSalesperson(data).subscribe({
      next: (data: any) => {
        this.loader = false;
        if (data.success == true) {
          const vendorId = data.vendorId;
          if (this.selectedFile) {
            this.uploadSalespersonImage(data.salespersonId);
          }
          this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
          setTimeout(() => this.route.navigate(['/home/listsalesPerson']), 1000);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        }
      },
      error: (error: any) => {
        this.loader = false;
        console.error('Error creating salesperson:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error creating salesperson' });
      }
    });
  }

  uploadSalespersonImage(salespersonId: number) {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);

      this.salespersonservice.uploadSalespersonImage(salespersonId, formData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image uploaded successfully.' });
          }
        },
      });
    }
  }

  updateSalesperson(data: any) {
    data.salespersonId = this.salespersonId;
    data.addressid = this.Addressid
    data.salespersonCode = data.salespersonCode;
    data.salespersonCode = data.salespersonCode.toString();
    const username = localStorage.getItem('username');
    data.updatedBy = username;
    if (data) {
      this.salespersonservice.updateSalesperson(data).subscribe({
        next: Data => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Salesperson Updated Successfully.' });
          if (this.selectedFile) {
            this.uploadSalespersonImage(data.salespersonId);
          }
          setTimeout(() => {
            this.route.navigate(['/home/listsalesPerson']);
          }, 1000);
        },
        error: error => {
          console.error('Error updating salesperson:', error);
        }
      });
    } else {
      this.createSalesperson(data);
    }
  }

  validateForm() {
    let isValid = true;
    if (this.salesPersonForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }
    return isValid;
  }

  get formControls() {
    return this.salesPersonForm.controls;
  }

  // deleteImage() {
  //   this.previewImage = undefined;
  // }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    const fileSizeKB: number = Math.round(file.size / 1024); // Convert bytes to KB
    if (fileSizeKB > 5000) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select an image file up to 5MB in size.' })
      return;
    }
    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a image.' })
      return;
    }
    if (file) {
      this.selectedFile = file;
      this.createImagePreview(file);
    }
  }

  createImagePreview(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.previewImage = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  show() {
    console.log(this.selectedFile);
  }

  deleteImage(): void {
    if (this.selectedFile || this.previewImage) {

      console.log('Deleting file:', this.selectedFile?.name || 'existing image');
      this.selectedFile = null;
      this.previewImage = null; // Clear the image preview
      this.salesPersonForm.controls.salespersonImage.setValue(null);
      this.fileInput.nativeElement.value = '';
    }
  }

  validater() {
    const customerCodeControl = this.salesPersonForm.get('salespersonCode');
    if (customerCodeControl?.invalid) {
      if (customerCodeControl.errors?.['required']) {
      }
      if (customerCodeControl.errors?.['pattern']) {
      }
    }
  }

  manualEntry() {
    const manualEntryValue = this.salesPersonForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.salesPersonForm.controls.salespersonCode.setValue('');
      this.isManual = false;

    } else {
      if (!this.isEditMode) {
        this.isManual = true
        this.getSalesPersonCode();
      }
    }
  }

  getSalesPersonCode() {
    this.loader = true;
    this.salespersonservice.autogenerateSalespersonCode().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'SP';
        // const salespersonCode = alphanumericCode + data;
        this.salesPersonForm.controls.salespersonCode.setValue(data.fullNumber);
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }

  checkSalesPersonCode() {
    if (!this.salesPersonForm.controls.salespersonCode.value) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter' });
      return;
    }
    if (!this.isEditMode) {
      this.salespersonservice.checkSalesPersonCode(this.salesPersonForm.controls.salespersonCode.value).subscribe(
        (data: any) => {
          if (data.success == true) {
          } else {
            this.salesPersonForm.controls.salespersonCode.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.salesPersonForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  // getStateList() {
  //   this.loader = true;
  //   this.customerService.getStateList().subscribe({
  //     next: (data: any) => {
  //       this.stateList = data;
  //       this.loader = false;
  //     },
  //     error: error => {
  //       console.log(error);
  //       this.loader = false;
  //     }
  //   });
  // }

    getStateList() {
  this.customerService.getStateList().subscribe({
    next: (data: any) => { 
      console.log('Raw state list from API:', data); 
      this.stateList = (data ?? []).sort((a: any, b: any) =>
        (a.stateName ?? a.name ?? a.label ?? '').localeCompare(
          b.stateName ?? b.name ?? b.label ?? ''
        )
      );
    },
    error: error => {
      console.log(error);
    }
  });
}

  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }

  // setState(event: any) {
  //   this.salesPersonForm.controls.address.controls.state.setValue(event.value.stateName);
  // }
  setState(event: any) {
    this.salesPersonForm.patchValue({
      //GSTIN: event.value.stateCode,
      address: {
        state: event.value.stateName,
        stateCode: event.value.stateCode,
        CreatedBy: localStorage.getItem('username'),
      }
    });
    if (this.isEditMode) {
      this.salesPersonForm.patchValue({
        //GSTIN: event.value.stateCode,
        address: {
          state: event.value.stateName,
          stateCode: event.value.stateCode,
          UpdatedBy: localStorage.getItem('username'),
        }
      });
    }
  }

  checkState() {
    const enteredState = this.salesPersonForm.controls.address.controls.state.value;
    const validStates = this.stateList.map(state => state.stateName);

    if (validStates.includes(enteredState)) {
    } else {
      this.salesPersonForm.controls.address.controls.state.setValue('');
    }
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault(); // Prevent form submission on Enter key press

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

}
